import { GraphUU } from '../../shared/interactive-graph/simple_graphs/graphUU';
import { NameVertex, Interactable } from 'graph-interactive';
import { AbstractNode } from 'graph-interactive/dist/lib/abstract/aNode';


export class FindSimplePathGraph extends GraphUU {
    private nextStepReset: boolean = false;

    /**
     * return -1: One path is not correct
     * return 0: Not all paths have been selected
     * return 1: all Paths have been selected
     */
    checkSelectedPath(paths: string[][], allPaths: string[][]): number {
        let isCorrect: boolean = true;
        let countPaths = paths.length;
        let countAll = this.countRealPaths(allPaths)[0];
        let correctPath = this.countRealPaths(allPaths)[1];

        paths.forEach(myPath => {
            let isIn: boolean = false;
            correctPath.forEach(cPath => {
                if (myPath.length == cPath.length) {
                    let n = myPath.length;
                    let sameString: boolean = true;
                    for (let i = 0; i < n; i++) {
                        if (myPath[i] != cPath[i]) {
                            sameString = false;
                        }
                    }
                    if (sameString) {
                        isIn = true;
                    }
                }
            })
            if (!isIn)
                isCorrect = false;
        })

        if (isCorrect && (countPaths == countAll))
            return 1;
        if (isCorrect) {
            return 0;
        } else {
            return -1;
        }
    }

    private countRealPaths(paths: string[][]): [number, string[][]] {
        let count: number = 0;
        let truePaths: string[][] = [];
        for (let i = 0; i < paths.length; i++) {
            let predecessor: AbstractNode = null;
            let isCorrect: boolean = true;
            let path: string[] = paths[i];
            for (let j = 0; j < path.length; j++) {
                let c: string = path[j];
                let node: AbstractNode = this.getNodePerName(c);
                if (node == null) {
                    isCorrect = false;
                    break;
                }
                if (predecessor == null) {
                    predecessor = node;
                } else {
                    if (this.graph.getEdge(predecessor, node) == null) {
                        isCorrect = false;
                        break;
                    }
                    predecessor = node;
                }
            }
            if (isCorrect) {
                count = count + 1;
                truePaths.push(path);
            }
        }
        return [count, truePaths];
    }


    getNodePerName(name: string): AbstractNode {
        let res: AbstractNode = null;
        this.graph.getNodes().forEach(n => {
            if (n instanceof NameVertex)
                if (n.getName() == name) {
                    res = n;
                }
        })
        return res;
    }

    disableHover(interactabe: Interactable): boolean {
        return false;
    }

    getActive(): Interactable {
        return null;
    }
}
